import { Injectable, inject } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { NavigationTarget } from './navigation-target';

/** Executes navigation decisions: Shell routes through the router, any other page through the browser. */
@Injectable({ providedIn: 'root' })
export class PortalNavigator {
  private readonly router = inject(Router);

  navigate(target: NavigationTarget): Promise<boolean> {
    if (target.kind === 'internal') {
      return this.router.navigateByUrl(target.url);
    }
    window.location.assign(target.url);
    return Promise.resolve(true);
  }

  /** Guard result: a Shell route becomes a redirect; any other page is opened and the current navigation is cancelled. */
  toGuardResult(target: NavigationTarget): UrlTree | false {
    if (target.kind === 'internal') {
      return this.router.parseUrl(target.url);
    }
    window.location.assign(target.url);
    return false;
  }
}
